/**
 * @generated SignedSource<<7bd021ba75b63413a00d6346f439cf5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTimeRegistrationGranularityInput = {
  id: string;
  granularity: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateTimeRegistrationGranularityMutation$variables = {
  input: UpdateTimeRegistrationGranularityInput;
};
export type UpdateTimeRegistrationGranularityMutation$data = {
  readonly updateTimeRegistrationGranularity: {
    readonly timeRegistrationSettings: {
      readonly id: string;
      readonly granularity: string | null;
    } | null;
  } | null;
};
export type UpdateTimeRegistrationGranularityMutation$rawResponse = {
  readonly updateTimeRegistrationGranularity: {
    readonly timeRegistrationSettings: {
      readonly id: string;
      readonly granularity: string | null;
    } | null;
  } | null;
};
export type UpdateTimeRegistrationGranularityMutation = {
  variables: UpdateTimeRegistrationGranularityMutation$variables;
  response: UpdateTimeRegistrationGranularityMutation$data;
  rawResponse: UpdateTimeRegistrationGranularityMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTimeRegistrationGranularityPayload",
    "kind": "LinkedField",
    "name": "updateTimeRegistrationGranularity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegistrationSettingsType",
        "kind": "LinkedField",
        "name": "timeRegistrationSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "granularity",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateTimeRegistrationGranularityMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateTimeRegistrationGranularityMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "06856bb3a9853dc7f671dcd2204398fd",
    "id": null,
    "metadata": {},
    "name": "UpdateTimeRegistrationGranularityMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateTimeRegistrationGranularityMutation(\n  $input: UpdateTimeRegistrationGranularityInput!\n) {\n  updateTimeRegistrationGranularity(input: $input) {\n    timeRegistrationSettings {\n      id\n      granularity\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5865d2570171fb8acceab0b06f3032ca";

export default node;
